import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_BANHANGTRAGOP } from "actions/BanHangTraGop/actionTypes";
import {
  getListBanHangTraGopSuccess,
  getListBanHangTraGopFailure,
} from "actions/BanHangTraGop";
import banHangTraGopApi from "service/banHangTraGopApi";
import { pushNotification } from "utils/notifications";

function* getListBanHangTraGop(action) {
  try {
    const response = yield call(banHangTraGopApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListBanHangTraGopSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListBanHangTraGopFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListBanHangTraGopFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_BANHANGTRAGOP, getListBanHangTraGop);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
